/**
 * @module createSanitizedMarkup
 * @since 2.22.0
 */

import { sanitize } from '../sanitize';

/**
 * Creates a ready-to-use object for React in the shape used by "dangerouslySetInnerHTML" and sanitizes the markup provided.
 * @param {String} [markup] Markup to be sanitized & parsed.
 * @param {String} [sanitizationGroup] Tags sanitization group.
 * @return { { __html: string } } Sanitized markup.
 * @see https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
 */
export const createSanitizedMarkup = (markup, sanitizationGroup) => (
    { __html: sanitize(markup, sanitizationGroup) }
);
